import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, debounceTime, fromEvent, takeUntil } from 'rxjs';
import { AuthService } from '../../pages/auth/auth.service';
import { RoleId } from 'src/app/pages/auth/role';
import { environment } from 'src/environments/environment';

export interface Menu {
  headTitle1?: string;
  level?: number;
  headTitle2?: string;
  path?: string;
  title?: string;
  type?: string;
  icon?: string;
  active?: boolean;
  bookmark?: boolean;
  pinnedData?: boolean;
  items?: Menu[];
  children?: Menu[];
  subtitle?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NavService {
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  private readonly unsubscriber: Subject<any> = new Subject();

  public language: boolean = false;

  public collapseSidebar: boolean = window.innerWidth < 1200 ? true : false;

  constructor(private readonly router: Router, private readonly authService: AuthService) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(0), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 1200) {
          this.collapseSidebar = true;
        } else {
          this.collapseSidebar = false;
        }
      });
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = this.returnMenuRole();
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  public returnMenuRole() {
    const userRoleId = this.authService.getRoleId();
    if (userRoleId && [RoleId.SA, RoleId.ADMIN].includes(userRoleId)) {
      return (this.MENUITEMS = [
        {
          headTitle1: 'Pages',
        },
        {
          level: 1,
          path: '/attivita',
          title: 'Gestione Attività',
          icon: 'attivita-icon',
          type: 'link',
        },
        ...(environment.production
          ? []
          : [
              {
                level: 1,
                path: '/attivita-new',
                title: 'Gestione Attività New',
                icon: 'attivita-icon',
                type: 'link',
              },
            ]),
        {
          level: 1,
          path: '/saggi',
          title: 'Gestione Saggi',
          icon: 'storage',
          type: 'link',
        },
        {
          level: 1,
          title: 'Anagrafiche',
          icon: 'anagrafiche',
          type: 'sub',
          active: true,
          children: [
            {
              path: '/anagrafiche/utenti',
              title: 'Utenti',
              type: 'link',
              bookmark: true,
            },
            {
              path: '/anagrafiche/strutture',
              title: 'Strutture',
              type: 'link',
            },
            { path: '/anagrafiche/prodotti', title: 'Prodotti', type: 'link' },
            { path: '/anagrafiche/attivita', title: 'Attività', type: 'link' },
            {
              path: '/anagrafiche/segmentazioni',
              title: 'Suddivisione',
              subtitle: 'Territoriale',
              type: 'link',
            },
            { path: '/anagrafiche/medici', title: 'Medici', type: 'link' },
            { path: '/anagrafiche/medici/consensi-medici', title: 'Consensi Medici', type: 'link' },
            { path: '/anagrafiche/campi-aggiuntivi', title: 'Campi Aggiuntivi', type: 'link' },
          ],
        },
        {
          level: 1,
          path: '/tipologiche',
          title: 'Tipologiche',
          icon: 'tipologiche',
          type: 'link',
        },
        {
          level: 1,

          title: 'Cicli',
          icon: 'cicli',
          type: 'link',
          children: [
            { path: '/cicli', title: 'Lista Cicli', type: 'link' },
            {
              path: '/cicli/nuovo-ciclo',
              title: 'Pianifica Ciclo',
              type: 'link',
            },
            {
              path: '/cicli/calendario',
              title: 'Calendario',
              type: 'link',
            },
          ],
        },
        {
          level: 1,
          path: 'report/calendario',
          title: 'Calendario',
          icon: 'calendarCicli',
          type: 'link',
        },
        {
          level: 1,
          path: 'report/report',
          title: 'Report',
          icon: 'report',
          type: 'link',
        },
        {
          level: 1,
          path: '/presenze',
          title: 'Fogli Presenze',
          icon: 'presenze',
          type: 'link',
        },
        {
          level: 1,
          path: '/note-spese',
          title: 'Note Spese',
          icon: 'spese',
          type: 'link',
        },
        {
          level: 1,
          path: '/profilo/visualizza',
          title: 'Area Personale',
          icon: 'profilo',
          type: 'link',
        },
      ]);
    } else if (userRoleId && [RoleId.AM].includes(userRoleId)) {
      return (this.MENUITEMS = [
        {
          level: 1,
          path: '/dashboard',
          title: 'Dashboard',
          icon: 'dashboard',
          type: 'link',
        },
        {
          level: 1,
          path: '/attivita',
          title: 'Gestione Attività',
          icon: 'attivita-icon',
          type: 'link',
        },
        ...(environment.production
          ? []
          : [
              {
                level: 1,
                path: '/attivita-new',
                title: 'Gestione Attività New',
                icon: 'attivita-icon',
                type: 'link',
              },
            ]),
        {
          level: 1,
          path: '/saggi',
          title: 'Gestione Saggi',
          icon: 'storage',
          type: 'link',
        },
        {
          level: 1,
          title: 'Anagrafiche',
          icon: 'anagrafiche',
          type: 'sub',
          active: true,
          children: [
            {
              path: '/anagrafiche/strutture',
              title: 'Strutture',
              type: 'link',
            },
            { path: '/anagrafiche/medici', title: 'Medici', type: 'link' },
            { path: '/anagrafiche/medici/consensi-medici', title: 'Consensi Medici', type: 'link' },
          ],
        },
        {
          level: 1,
          title: 'Cicli',
          icon: 'cicli',
          type: 'link',
          children: [{ path: '/cicli', title: 'Lista Cicli', type: 'link' }],
        },
        {
          level: 1,
          path: 'report/calendario',
          title: 'Calendario',
          icon: 'calendarCicli',
          type: 'link',
        },
        {
          level: 1,
          path: 'report/report',
          title: 'Report',
          icon: 'report',
          type: 'link',
        },
        {
          level: 1,
          path: '/presenze',
          title: 'Fogli Presenze',
          icon: 'presenze',
          type: 'link',
        },
        {
          level: 1,
          path: '/note-spese',
          title: 'Note Spese',
          icon: 'spese',
          type: 'link',
        },
        {
          level: 1,
          path: '/profilo/visualizza',
          title: 'Utente',
          icon: 'profilo',
          type: 'link',
        },
      ]);
    } else {
      return (this.MENUITEMS = [
        {
          level: 1,
          path: '/profilo/visualizza',
          title: 'Utente',
          icon: 'profilo',
          type: 'link',
        },
        {
          level: 1,
          path: 'report/report',
          title: 'Report',
          icon: 'report',
          type: 'link',
        },
      ]);
    }
  }

  ngOnDestroy() {
    this.unsubscriber.complete();
  }
}
